import React, { useState, useEffect, useRef, createRef } from 'react';
import FractionalHeroSection from '../../../components/landingPage/FractionalPage/FractionalHeroSection'
import FractionHelpSection from '../../../components/landingPage/FractionalPage/FractionHelpSection'
import FractionalCarouselSection from '../../../components/landingPage/FractionalPage/FractionalCarouselSection'
import FractionHelpClientSection from '../../../components/landingPage/FractionalPage/FractionHelpClientSection'
import FractionInvestmentSection from '../../../components/landingPage/FractionalPage/FractionInvestmentSection'
import HowItsWorkSection from '../../../components/landingPage/homePage/HowItsWorkSection'
import { COMPONENT_REF } from './Companies';
import RegisterSection from '../../../components/landingPage/homePage/RegisterSection';
import FractionHelpClientInfoModal from '../../../components/modals/FractionHelpClientInfoModal';
import FractionalInvestmentModal from '../../../components/modals/FractionalInvestmentModal';
import FractionHelpClientModal from '../../../components/modals/FractionHelpClientModal';

const Fractional = () => {

    const refs = useRef(COMPONENT_REF.map(() => createRef()));
    const [isAnimationVisible, setIsAnimationVisible] = useState(false);
    const [journeyModalType, setJourneyModalType] = useState('Investment Journey');
    const [helpClientModal, setHelpClientModal] = useState('reduce')

    useEffect(() => {
        const observers = refs.current.map((ref, index) =>
            new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsAnimationVisible(prev => ({ ...prev, [index]: true }));
                    }
                },
                { threshold: 0.5 }
            )
        );

        refs.current.forEach((ref, index) => {
            if (ref.current) {
                observers[index].observe(ref.current);
            }
        });

        return () => {
            refs.current.forEach((ref, index) => {
                if (ref.current) {
                    observers[index].unobserve(ref.current);
                }
            });
        };
    }, []);

    const HOW_ITS_WORK_DATA = {
        IMAGES_ARRAY: [
            {
                title1: 'Register',
                desc: `Have a no-commitment look around - our platform is FREE for advisors like you.`
            },
            {
                title1: 'Onboard a Client',
                desc: 'When you are ready, add one or more of your client companies onto your dashboard.  We add value whatever stage your client is at.'
            },
            {
                title1: 'Activate Pro Subscription',
                desc: 'Either you or your client activates Pro subscription.  Clients subscribing via you get a 20% discount.'
            },
            {
                title1: 'Work Collaboratively',
                desc: 'Either your client can complete modules under your oversight, or you can do so yourself.'
            },
            {
                title1: 'Start Creating Value',
                desc: 'Work collaboratively with your clients to create value for everyone. Quick results visible to client.'
            },
            {
                title1: 'Identify New Projects',
                desc: 'The process of completing modules, will uncover new opportunities for you to help your client create further value.'
            },
        ],
        title: 'How it works?',
        description: 'Rapidly make yourself irreplaceable!'
    };

    return (
        <div className='pb5rem fractional-page'>
            <FractionalHeroSection />
            <FractionHelpSection />
            <FractionalCarouselSection />
            <FractionHelpClientSection setHelpClientModal={setHelpClientModal} />
            <FractionInvestmentSection setJourneyModalType={setJourneyModalType} />

            <HowItsWorkSection data={HOW_ITS_WORK_DATA} refs={refs} isAnimationVisible={isAnimationVisible} />

            {/* Regsiter form section */}
            <RegisterSection registerationType='Advisor' refs={refs} isAnimationVisible={isAnimationVisible} />

            {/* Modals */}
            <FractionHelpClientInfoModal />
            <FractionalInvestmentModal modalType={journeyModalType} />
            <FractionHelpClientModal helpClientModal={helpClientModal} />
        </div>
    )
}

export default Fractional